// Allowlist of emails permitted to see and toggle the Experimental Features
// section. Kept narrow on purpose — this is a per-user opt-in for in-progress
// tools, not a role-wide capability. Update this array to expand access.
const ALLOWLIST: ReadonlySet<string> = new Set(["steddyadmin@steddy.com"]);

export function isExperimentalFeaturesUser(email: string | undefined): boolean {
  if (!email) return false;
  return ALLOWLIST.has(email.toLowerCase());
}
